export function safeParseJson<T>(
  src?: string,
  onError?: (e: unknown) => void,
): T | null {
  if (!src || src === '{}') {
    return null
  }

  try {
    return JSON.parse(src)
  } catch (e) {
    onError?.(e)
    return null
  }
}

export function safeParseJsonArray<T>(src: string | null): T[] {
  try {
    const value = src ? safeParseJson(src) : []
    return Array.isArray(value) ? value : []
  } catch {
    return []
  }
}

export type Serializable =
  | bigint
  | boolean
  | null
  | number
  | string
  | Date
  | object // Should be '{ [key: string]: Serializable }' but helper gets called with loosely-typed 'object' and interfaces
  | Serializable[]

export function jsonStringifyWithBigIntSanitization(
  serializable: Serializable,
): string {
  return JSON.stringify(
    serializable,
    (_, value) =>
      typeof value === 'bigint' ? `0x${value.toString(16)}` : value, // return everything else unchanged
  )
}
